import { Alert, Snackbar } from '@mui/material'
import moment from 'moment'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useResetRecoilState } from 'recoil'
import { formDataState } from './helpers'

function SessionTimeoutHandler({ isSuccessErrorPage }) {
  const resetData = useResetRecoilState(formDataState)
  const [events] = useState(['click', 'load', 'scroll'])
  const [isOpen, setOpen] = useState(false)
  const navigate = useNavigate()

  let startTimerInterval = useRef()

  // start inactive check
  let timeChecker = useCallback(() => {
    startTimerInterval.current = setTimeout(() => {
      clearTimeout(startTimerInterval.current)
      let storedTimeStamp = localStorage.getItem('lastTimeStamp')
      let timeOutInterval = 1800000 // 30minutes
      const diff = moment.duration(moment().diff(moment(storedTimeStamp)))
      if (diff._milliseconds < timeOutInterval) {
        timeChecker()
      } else {
        setOpen(true)
        localStorage.removeItem('lastTimeStamp')
      }
    }, 1800000) // 30minutes check
  }, [])

  // reset interval timer
  let resetTimer = useCallback(() => {
    clearTimeout(startTimerInterval.current)
    localStorage.setItem('lastTimeStamp', moment())

    timeChecker()
  }, [timeChecker])

  // handle close snackbar
  const handleClose = () => {
    events.forEach((event) => {
      window.removeEventListener(event, resetTimer)
    })
    setOpen(false)
    resetTimer()
    sessionStorage.clear()
    resetData()
    navigate('/', { replace: true })
  }

  useEffect(() => {
    if (isSuccessErrorPage) {
      // skip checking for SuccessError Page
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer)
      })
      clearTimeout(startTimerInterval.current)
    } else {
      events.forEach((event) => {
        window.addEventListener(event, resetTimer)
      })

      timeChecker()
    }

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer)
      })
      clearTimeout(startTimerInterval.current)
    }
  }, [resetTimer, events, isSuccessErrorPage, timeChecker])

  return (
    <>
      {!isSuccessErrorPage && (
        <Snackbar
          open={isOpen}
          sx={{ height: '100%', left: '0px' }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
        >
          <Alert
            onClose={handleClose}
            severity="error"
            sx={{ m: { xs: '0 30px' } }}
          >
            Your session has timed out due to inactivity. Please try again.
          </Alert>
        </Snackbar>
      )}
    </>
  )
}

SessionTimeoutHandler.propTypes = {
  isSuccessErrorPage: PropTypes.bool,
}

export default SessionTimeoutHandler
